import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { BRAND } from "../lib/brand";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { PasswordInput } from "../components/ui/password-input";
import { Label } from "../components/ui/label";
import { ThemeToggle } from "../components/ThemeToggle";

const FIELDS = [
  ["name", "Nama Pemilik", "text", true],
  ["store_name", "Nama Toko", "text", true],
  ["email", "Email (untuk login)", "email", true],
  ["phone", "No. HP / WhatsApp", "tel", false],
  ["password", "Password (min. 8 karakter, huruf & angka)", "password", true],
];

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", store_name: "", email: "", phone: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await register(f);
      nav("/pengaturan?tab=store", { replace: true });
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-6 sm:p-10">
      <div className="flex justify-end"><ThemeToggle /></div>
      <div className="flex-1 grid place-items-center">
        <form onSubmit={submit} className="w-full max-w-md space-y-5 fade-up" data-testid="register-form">
          <img src={BRAND.logoFull} alt={BRAND.name} className="h-24 w-auto mx-auto" />
          <div className="text-center">
            <h1 className="font-display text-3xl font-extrabold tracking-tight">Daftar Toko Baru</h1>
            <p className="text-muted-foreground mt-1 text-sm">Buat akun owner, lalu tambahkan kasir dan atur toko Anda.</p>
          </div>
          {FIELDS.map(([k, l, t, req]) => (
            <div key={k} className="space-y-1.5">
              <Label htmlFor={k}>{l}</Label>
              {k === "password" ? (
                <PasswordInput id={k} required={req} minLength={8} className="h-11" value={f[k]}
                  onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`register-${k}-input`} />
              ) : (
                <Input id={k} type={t} required={req} className="h-11" value={f[k]}
                  onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`register-${k}-input`} />
              )}
            </div>
          ))}
          {err && <div className="text-sm text-destructive bg-destructive/10 rounded-lg px-3 py-2" data-testid="register-error">{err}</div>}
          <Button type="submit" className="w-full h-11 text-base font-semibold" disabled={loading} data-testid="register-submit-btn">
            {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Buat Akun & Toko
          </Button>
          <p className="text-sm text-center text-muted-foreground">
            Sudah punya akun? <Link to="/login" className="text-primary font-semibold hover:underline" data-testid="go-login-link">Masuk</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
